<template>
    <div>
        <v-app class="d-flex flex-column">
            <v-main class="daon-main-wrap">
                <router-view :key="['ShopDetails', 'ShopCoupons', 'ShopProducts'].includes($route.name) ? null : $route.path"></router-view>
            </v-main>
        </v-app>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    export default {
        metaInfo() {
            return {
                title: this.appMetaTitle,
            };
        },
        components: {},
        computed: {
            ...mapGetters('auth', ['isAuthenticated']),
            ...mapGetters('app', ['appMetaTitle', 'userLanguageObj', 'routerLoading']),
        },
        methods: {
            ...mapActions('auth', ['getUser', 'checkSocialLoginStatus']),
            ...mapMutations('auth', ['setSociaLoginStatus']),
        },
        async created() {
            this.$vuetify.rtl = false;

            await this.getUser();

            setTimeout(() => {
                this.checkSocialLoginStatus();
            }, 200);
        },
    };
</script>
<style scoped>
    .absolute-full {
        background: #fff;
        z-index: 10000;
    }
</style>
